export default __webpack_public_path__ + "static/media/mock-bg.cb030d6a.jpeg";